import {cx} from "@emotion/css";

import {ReactComponent as SvgDarkBg} from "~/assets/svg/dark-bg.svg";

import {otherIconStyles} from "../styles";
import {IIconBase} from "../../_common/types";

export const BmDarkBg: React.FC<IIconBase> = ({id, className}) => {
  return <SvgDarkBg id={id} className={cx(otherIconStyles.bg, className)} />;
};
